import type { VoidFunctionComponent } from 'react';

import FilterCard from '../../../../../../../../generic/Filter/FilterCard';
import { ProjectSource } from '../../../../../../../../../../typings/enums';
import type { ProjectsFilter } from '../../../../../../../../../../shared/projectsV2';
import { selectOptionFactory } from '../../../../../../../../../utils';

type Props = {
  setFilters: (filter: ProjectsFilter) => void;
  filters: ProjectsFilter;
};

export const PROJECT_SOURCE_OPTIONS = [
  selectOptionFactory(ProjectSource.Provided, 'CLI upload'),
  selectOptionFactory(ProjectSource.Container, 'Container'),
  selectOptionFactory(ProjectSource.Archive, 'Archive upload'),
  selectOptionFactory(ProjectSource.Autobuild, 'Quick import'),
  selectOptionFactory(ProjectSource.SBOM, 'SBOM import'),
];

export const ProjectSourceFilter: VoidFunctionComponent<Props> = ({ setFilters, filters }) => {
  const handleSourceChange = (selected: typeof PROJECT_SOURCE_OPTIONS) => {
    setFilters({ ...filters, type: selected.map((selection) => selection.value) });
  };

  const selectedProjectSources = filters.type?.map((selectedType) => selectOptionFactory(selectedType));

  return (
    <FilterCard.Checkboxes
      label="Project source"
      options={PROJECT_SOURCE_OPTIONS}
      values={selectedProjectSources ?? []}
      onChange={handleSourceChange}
    />
  );
};
